/* eslint-disable */
export default {
	data() {
		return {
			heraUrl: process.env.VUE_APP_HERA_LINK
		};
	},
	computed: {},
	mounted() {},
	methods: {
		buttonSyncBackToUA() {
			if (typeof MobileJS != "undefined") {
				MobileJS.closePaxelWebview();
			} else if (typeof webkit != "undefined") {
				try {
					webkit.messageHandlers.closePaxelWebview.postMessage("closePaxelWebview");
				} catch (err) {
					console.log("The native context does not exist yet");
				}
			} else {
				this.$router.go("-1");
			}
		},
		buttonSyncCopyClipboard: text => {
			if (typeof MobileJS != "undefined") {
				MobileJS.copyClipboard(text);
			} else if (typeof webkit != "undefined") {
				try {
					webkit.messageHandlers.copyClipboard.postMessage(text);
				} catch (err) {
					console.log("The native context does not exist yet");
				}
			} else {
				var dummy = document.createElement("input");
				document.body.appendChild(dummy);
				dummy.value = text;
				dummy.select();
				document.execCommand("copy");
				document.body.removeChild(dummy);
			}
		},
		buttonSyncOpenGmapLink(link_url) {
			if (typeof MobileJS != "undefined") {
				MobileJS.openGmapLink(JSON.stringify({ url: link_url }));
			} else if (typeof webkit != "undefined") {
				try {
					webkit.messageHandlers.openGmapLink.postMessage(JSON.stringify({ url: link_url }));
				} catch (err) {
					console.log("The native context does not exist yet");
				}
			} else {
				window.open(link_url, "_blank");
			}
		},
		buttonSyncOpenGmapLocation(lat, long, url) {
			if (typeof MobileJS != "undefined") {
				MobileJS.openGmapLocation(JSON.stringify({ lat: lat, long: long }));
			} else if (typeof webkit != "undefined") {
				try {
					webkit.messageHandlers.openGmapLocation.postMessage(
						JSON.stringify({ lat: lat, long: long })
					);
				} catch (err) {
					console.log("The native context does not exist yet");
				}
			} else {
				if (url) {
					window.open(url, "_blank");
				}
			}
		},
		buttonSyncShareOrder(order_detail) {
			if (typeof MobileJS != "undefined") {
				MobileJS.shareOrder(JSON.stringify(order_detail));
			} else if (typeof webkit != "undefined") {
				try {
					webkit.messageHandlers.shareOrder.postMessage(JSON.stringify(order_detail));
				} catch (err) {
					console.log("The native context does not exist yet");
				}
			} else {
				console.log("function is not support by browser");
			}
		},
		buttonContactSupport() {
			if (typeof MobileJS != "undefined") {
				MobileJS.contactSupport(JSON.stringify({ title: "Yellow AI" }));
			} else if (typeof webkit != "undefined") {
				try {
					webkit.messageHandlers.contactSupport.postMessage(JSON.stringify({ title: "Yellow AI" }));
				} catch (err) {
					console.log("The native context does not exist yet");
				}
			} else {
				window.location.href = this.heraUrl;
			}
		},
		recordEvent(action, payload) {
			if (typeof MobileJS != "undefined") {
				MobileJS.recordEvent(JSON.stringify({ title: action, payload: payload }));
			} else if (typeof webkit != "undefined") {
				try {
					webkit.messageHandlers.recordEvent.postMessage(
						JSON.stringify({ title: action, payload: payload })
					);
				} catch (err) {
					console.log("The native context does not exist yet");
				}
			}
		}
	}
};
